import { createContext, useContext, useEffect, ReactNode, Dispatch, SetStateAction } from 'react';
export const HeaderExtraContext = createContext<Dispatch<SetStateAction<ReactNode>>>(() => {});

export const useHeaderExtra = (node: ReactNode) => {
    const setHeaderExtra = useContext(HeaderExtraContext);

    useEffect(() => {
        setHeaderExtra(node);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [node]);

    useEffect(() => {
        return () => setHeaderExtra(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
